import { Injectable } from '@angular/core'
import { HttpHeaders } from '@angular/common/http'

@Injectable()
export class global
{
    public static readonly baseAPIUrl: string = "https://www.ask4token.com/";
    public static readonly termConditionLink: string = "https://myciti.in/privacy-policy/";
    public static readonly imageUrl: string = "https://www.ask4token.com/bom/newbom_api/netsol/getimg.php?storeid=";
    public static readonly getStickerUrl: string = "https://www.ask4token.com/bom/newbom_api/netsol/stick.php?a=";

    public static readonly httpOptions = {
        headers: new HttpHeaders({
            'Content-Type':'application/json'
        })
    };
}